// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  name: 'Think Client Common API Test',
  logo: '""',
  apiUrl: 'https://backend.preprod.common.thinkinsurtech.com',
  dashboardURL: 'https://preprod-corporate.common.thinkinsurtech.com/dashboard',
  loginURL: 'https://preprod-corporate.common.thinkinsurtech.com',
  clientConfigUrl: '',
  storagePath: 'https://backend.preprod.common.thinkinsurtech.com/api/Storages/documentation/download',
  imagePath: 'https://backend.preprod.common.thinkinsurtech.com/api/Storages/logos/download',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
